import RejectCardsForm from './RejectCardsForm';

export default RejectCardsForm;
